import AppConfig from '@/configs/app.config.js'
import axios from 'axios';

axios.defaults.baseURL = AppConfig.api.url;

axios.interceptors.request.use(function(config) {
  config.withCredentials = true
  return config;
}, function(error) {
  // Do something with request error
  return Promise.reject(error);
});

export default axios
